var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picture',[_vm._l((_vm.imageSizes),function({ resolution, size }){return _c('source',{key:resolution,attrs:{"media":`(min-width: ${resolution}px)`,"srcset":`${_vm.url}${_vm.url.includes('?') ? '&' : '?'}w=${size}&fmt=webp`}})}),_vm._v(" "),_c('img',{attrs:{"height":_vm.height,"width":_vm.width,"src":_vm.url,"alt":_vm.alt,"loading":"lazy"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }